import React from "react";
import { UserRound } from "lucide-react";

import ViewContainer from "../../../../components/layout/view/ViewContainer";
import ContentPanel from "../../../../components/layout/content/ContentPanel";
import ContentPanelHeader from "../../../../components/layout/content/ContentPanelHeader";
import ContentItem from "../../../../components/layout/content/ContentItem";

import Text from "../../../../components/typography/Text";
import EmptyState from "../../../../components/feedback/EmptyState";

export default function TalentOverviewView({ profile }) {
  const bio = profile?.bio?.trim();

  return (
    <ViewContainer>
      <ContentPanel>
        <ContentPanelHeader
          title="Bio"
          subTitle="My sporting profile and journey."
        />

        {bio ? (
          <ContentItem>
            <Text as="p" className="user-talent__body">
              {bio}
            </Text>
          </ContentItem>
        ) : (
          <EmptyState
            icon={<UserRound size={28} />}
            title="No bio added yet"
            description="Sporting profile information will appear here when available."
          />
        )}
      </ContentPanel>
    </ViewContainer>
  );
}
